import { Flex } from '@mantine/core';
import { DS_AI_MOTION } from '@dealstack/frontend/app/pages/Project/Cap/DealstackAi/theme/dealstackAi.tokens';
import { fadeRise } from '@dealstack/frontend/app/pages/Project/Cap/DealstackAi/theme/dealstackAi.animations';
import { PROCESSING_CENTRE_STYLES } from '../../../../AnalysisWorkspace/processing/processing.styles';
import { ProcessingCard } from '../../../ProcessingCard/ProcessingCard';
import { useProcessingPanelController } from './useProcessingPanelController';

interface Props {
	dealId: string;
	batchId: string;
	onClose: () => void;
}

/** The processing checklist, centred in the modal. */
export const ProcessingPanel = ({ dealId, batchId, onClose }: Props) => {
	const { processing, actions } = useProcessingPanelController(dealId, batchId, onClose);

	return (
		<Flex
			flex={1}
			align="flex-start"
			justify="center"
			miw={0}
			mih={0}
			styles={{
				root: {
					...PROCESSING_CENTRE_STYLES,
					animation: `${fadeRise} ${DS_AI_MOTION.slowMs}ms ${DS_AI_MOTION.easeOut} both`,
				},
			}}
		>
			<ProcessingCard
				{...processing.card}
				batchTitle={processing.batchTitle}
				actions={actions}
			/>
		</Flex>
	);
};
